'use client';

import { useEffect, useState } from 'react';

import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

import avatar1 from '@/app/(homepage)/avatars/avatar-001.jpg';
import avatar2 from '@/app/(homepage)/avatars/avatar-002.jpg';
import avatar3 from '@/app/(homepage)/avatars/avatar-003.jpg';
import avatar4 from '@/app/(homepage)/avatars/avatar-004.jpg';
import { SubmitButton } from '@/components/FormElements';
import { Typography } from '@/components/Typography';
import { getSubscriberCount } from '@/lib/1440api/dataFetchers/getSubscriberCount';
import { useNewsletterSubscribeForm } from '@/providers';

export function NewsletterSubscribeSection() {
  const [count, setCount] = useState({ abbr: '4.3', commaSep: '4,359,134' });

  const {
    formState,
    formMessage,
    showContactLink,
    responseSentiment,
    inputProps,
    contactPath,
  } = useNewsletterSubscribeForm();

  // TODO: move to page level fetch
  useEffect(() => {
    (async () => {
      const count = await getSubscriberCount();
      setCount(count);
    })();
  }, []);

  return (
    <div className="bg-blue-100 rounded-4 p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-5 md:gap-10 mt-7 md:mt-10">
      <div className="flex flex-col items-start gap-6 grow">
        <span className="text-heading-350 flex px-3 py-1 rounded-full bg-blue-200 text-blue-700">
          Flagship Newsletter
        </span>
        <p>
          <span className="font-600">
            Receive the most impactful stories of the day
          </span>
          , expertly curated and explained for the intellectually curious. Join
          our community of over {count.abbr} subscribers.
        </p>
        {/* <div className="flex flex-col gap-1">
          <h3 className="text-display-800 font-serif">1440 Daily Digest</h3>
          <p className="text-body-400">
            Delivers the most impactful stories of the day, expertly curated and
            explained for the intellectually curious. Join our community of over{' '}
            {count.abbr} subscribers.
          </p>
        </div> */}

        <div className="flex gap-x-4 gap-y-2 items-center flex-wrap">
          <div className="flex items-center pl-3">
            {[avatar1, avatar2, avatar3, avatar4].map((src, index) => (
              <Image
                key={index}
                src={src}
                alt="Image of a person"
                className="w-7 h-7 md:w-11 md:h-11 rounded-full border-2 md:border-4 border-blue-100 -ml-3"
              />
            ))}
          </div>
          <div className="flex items-end gap-2">
            <span className="text-condensed-750 md:text-condensed-1000 font-numbers-sans bg-yellow-400">
              {count.commaSep}
            </span>{' '}
            <span className="text-body-300 md:text-body-400 pb-1">
              readers today
            </span>
          </div>
        </div>
      </div>
      <div className="md:basis-[35rem] lg:basis-[40rem] shrink-0 flex flex-col gap-3">
        <div className="flex flex-col gap-2 sm:gap-3">
          <input
            className="min-h-button-xl rounded-full px-5 py-2 bg-paper grow border border-blue-200"
            {...inputProps}
          />
          <SubmitButton
            loading={formState === 'loading'}
            variant="solid"
            color="blue"
            size="xl"
            className="relative md:min-w-[22rem]"
          >
            Subscribe
          </SubmitButton>
        </div>
        {formMessage && (
          <div
            className={classNames('mt-4 border rounded-2 px-4 py-3', {
              'bg-red-100 border-red-300': responseSentiment === 'failure',
            })}
          >
            <Typography
              name="body-350"
              tag="p"
              className={classNames({
                'text-red-700': responseSentiment === 'failure',
              })}
            >
              {formMessage}
              {showContactLink && (
                <Link href={contactPath} className="block mt-1 text-link">
                  Contact us if you need help
                </Link>
              )}
            </Typography>
          </div>
        )}

        <p className="text-center text-body-300 sm:text-body-350">
          100% Free, unsubscribe anytime
        </p>
      </div>
    </div>
  );
}
